import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NxLayoutComponent, NxRowComponent, NxColComponent } from '@allianz/ng-aquila/grid';
import { NxMessageComponent } from '@allianz/ng-aquila/message';

@Component({
  selector: 'ps20-frontend-hinweis',
  templateUrl: './hinweis.component.html',
  imports: [NxLayoutComponent, NxRowComponent, NxColComponent, NxMessageComponent],
})
export class HinweisComponent {
  @Input() content: SafeHtml | string;
  @Input() alignToLeft: boolean;
}
